import { React, useEffect } from "react";
import {
  Font,
  Slot,
  Icon,
  Badge,
  Button,
  Search,
  AccordionV2,
  AccordionItemV2,
  Breadcrumb,
  Dropdown,
  TextInput,
  Tag,
  Tab,
  TabsNavigation,
  Label,
  LoadingSpinner,
  Link,
  Switcher
} from "pepsico-ds";
import "./myidm-view1.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useContext } from "react";
import {
  UserProfileContext,
} from "../../common/user_profile_context.jsx";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import page from "../../Component-Library/Error404";
import axios from "axios";

const NewOrModifyAccess = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [requestOthersSelectedIndex, setRequestOthersSelectedIndex] = useState(0);
  const [requestOthersGPID, setRequestOthersGPID] = useState("");
  const [requestOthersSelectedValue, setRequestOthersSelectedValue] = useState([{
                displayText: `${t('myIdmPortal.first_name')}`,
                id: '1',
              }]);
  const [requestOthersSelectedDdLabel, setRequestOthersSelectedDdLabel] = useState(t('myIdmPortal.first_name'));
  const [requestOthersSelectedText, setRequestOthersSelectedText] = useState("");
  const { userProfile } = useContext(UserProfileContext);

  const onClickFindProfile = () => {
    if(requestOthersSelectedIndex == 0 && requestOthersGPID?.length !== 8){
      toast.error(t("auditRequest.gpid_limit_message"));
      return
    }else{
      if(userProfile?.pepappiamcentralfeatures?.includes('RequestAccess')) {
        let statePayload = {};
  
        if (requestOthersSelectedIndex == 0 && requestOthersGPID) {
          statePayload = { type: `${t('RequestNewAccessForOthers.gpid')}`, value: requestOthersGPID };
          navigate("/request-new-access-others", { state: statePayload });
        }
        else if (requestOthersSelectedValue && requestOthersSelectedText) {
          statePayload = { type: requestOthersSelectedValue?.[0]?.displayText, value: requestOthersSelectedText };
          navigate("/request-new-access-others", { state: statePayload });
        }
      }
      else{
        window.open(
          "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestAccessForOtherAssociate",
          "_blank"
        );
      }
    }
  }
  const requestOthersOnChangeDropdown = (value) => {
    setRequestOthersSelectedValue(value);
    setRequestOthersSelectedDdLabel(value[0].displayText)
  }
  const requestOthersOnUpdateSearchValue = (e) => {
    setRequestOthersSelectedText(e);
  }
  return (
    <div className="my-request-container">
      <TabsNavigation selectedIndex={requestOthersSelectedIndex}>
        <Tab label={`${t('RequestNewAccessForOthers.gpid')}`} onClick={() => setRequestOthersSelectedIndex(0)} />
        <Tab label={`${t('RequestNewAccessForOthers.other_options')}`} onClick={() => setRequestOthersSelectedIndex(1)} />
      </TabsNavigation>
      <br></br>

      {(requestOthersSelectedIndex == 0) && (
        <>
          {/* <Label
            className=""
            label={`${t('RequestNewAccessForOthers.gpid')}`}
            style={{}}
          /> */}
          <Search
            icon=""
            className=""
            isClearable={requestOthersGPID.length>0}
            menuPosition="bottom-right"
            onClear={function oFe() { }}
            onSearch={function oFe() { }}
            onSelectOption={function oFe() { }}
            onUpdate={(e) =>{
              const GPID = e?.replace?.(/[^0-9]/g, "");
              setRequestOthersGPID(GPID);
            }}
            onKeyDown={(event) => {
                if (event.key === "Enter" && !(requestOthersSelectedIndex == 0 ? false : (!requestOthersSelectedText || requestOthersSelectedText.length < 2))) {
                  onClickFindProfile()
                }
              }}
            delay={0}
            placeholderText={`${t('RequestNewAccessForOthers.type_gpid')}`}
            size="medium"
            style={{maxWidth:"revert"}}
            value={requestOthersGPID}
          />
        </>
      )}
      {(requestOthersSelectedIndex == 1) && (
        <>
          <Dropdown
            childList={[
              {
                displayText: `${t('myIdmPortal.first_name')}`,
                id: '1',
              },
              {
                displayText: `${t('myIdmPortal.last_name')}`,
                id: '2',
              },
              {
                displayText: `${t('myIdmPortal.email')}`,
                id: '3',
              }
            ].sort((a, b) => { return a.displayText.localeCompare(b.displayText); })}
            label={`${t('RequestNewAccessForOthers.search_by')}`}
            selectedValue={
              requestOthersSelectedValue}
            placeholder={`${t('RequestGPIDForNonEmployee.search')}...`}
            isClearable={false}
            selection="single"
            size="medium"
            className="other-options"
            setSelectedValue={(value) => requestOthersOnChangeDropdown(value)}
            style={{ marginBottom: "16px" }}
            onKeyDown={(e) => e.preventDefault()}
          />

          <TextInput
            className=""
            feedbackType="info"
            inputSize="medium"
            label={`${requestOthersSelectedDdLabel}`}
            // label=""
            onChange={function oFe() { }}
            onUpdate={(e) => requestOthersOnUpdateSearchValue(e)}
            onKeyDown={(event) => {
                if (event.key === "Enter" && !(requestOthersSelectedIndex == 0 ? false : (!requestOthersSelectedText || requestOthersSelectedText.length < 2))) {
                  onClickFindProfile()
                }
              }}
            placeholderText={`${t('RequestNewAccessForOthers.enter')} ${requestOthersSelectedDdLabel}`}
            prefixType="none"
            style={{}}
            suffixType="none"
            type="text"
            value={requestOthersSelectedText}
          />
        </>
      )}
      <button
        className="request-button"
        onClick={() => onClickFindProfile()}
        disabled={requestOthersSelectedIndex == 0 ? false : (!requestOthersSelectedText || requestOthersSelectedText.length < 2)}
      >
        <span>{`${t('RequestNewAccessForOthers.find_profile')}`}</span>
        <Icon
          alt=""
          icon="arrow_forward"
          size="medium"
          style={{ marginLeft: '4px' }}
        />
      </button>
        <hr />
        <div className="mb-2" style={{fontWeight:"bold", fontSize:"14px"}}>Other Requests</div>
        <div className="d-flex justify-content-between">
          <div style={{fontSize:"14px"}}>
            {t("homePage.sap_access_request")}
          </div>
          <div
            className="link mb-2"
            onClick={() => {
              window.open(
                "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestSAPAccess%7D&task.clear=1",
                "_blank"
              );
            }}
            style={{ fontSize: "10px" }}
          >
            <Icon
              alt="alt value"
              icon="arrow_forward"
              size="medium"
              style={{ marginLeft: '4px' }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div style={{fontSize:"14px"}}>
            {t("homePage.technology_application_request")}
          </div>
          <div
            className="link"
            onClick={() => {
              window.open(
                "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.TechnologyRequest.name%7D&task.clear=1",
                "_blank"
              );
            }}
            style={{ fontSize: "10px" }}
          >
            <Icon
              alt="alt value"
              icon="arrow_forward"
              size="medium"
              style={{ marginLeft: '4px' }}
            />
          </div>
        </div>
    </div>
  );
}

const MyidmView1 = ({roles}) => {
  const { t,i18n } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { userProfile } = useContext(UserProfileContext);
  const isManager = userProfile?.isManager ?? false;
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [gpid, setGpid] = useState("");
  const [searchByValue, setSearchByValue] = useState("first_name");
  const [otherOptionsValue, setOtherOptionsValue] = useState();
  const [selectedProfileValue, setSelectedProfileValue] = useState([{
    displayText: t('myIdmPortal.first_name'),
    id: 'first_name',
  }])

  const [requestOthersSelectedIndex, setRequestOthersSelectedIndex] = useState(0);
  const [requestOthersSelectedValue, setRequestOthersSelectedValue] = useState(t('updateProfile.firstName'));
  const [requestOthersSelectedDdLabel, setRequestOthersSelectedDdLabel] = useState(t('updateProfile.firstName'));
  const [requestOthersGPID, setRequestOthersGPID] = useState("");
  const [requestOthersSelectedText, setRequestOthersSelectedText] = useState("");

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedDdLabel, setSelectedDdLabel] = useState("GPID");
  const [selectedValue, setSelectedValue] = useState([{
    displayText: t('myIdmPortal.gpid'),
    id: '1',
  }]);
  const [selectedText, setSelectedText] = useState("");
    const { REACT_APP_API_ENDPOINT } = process.env;
  const [countStatus, setCountStatus] = useState(false);
  const [myidMApprovalCount, setMyidMApprovalCount] = useState(0);
  const [pepAGMApprovalCount, setPepAGMApprovalCount] = useState(0);
  const [entraCount, setEntraCount] = useState(0);
  const [myPamCount, setMyPamCount] = useState(0);
  const [selectedPendingApprovalTabIndex, setSelectedPendingApprovalTabIndex] = useState(0);
  const applicationOnboarding = [{label: t("homePage.rapid_application_onboarding"), path: "https://myidm.mypepsico.com/pepsicorao/request/index.html", icon: "assignment_turned_in"}, ...( userProfile?.raoApprovalsEnabled ? [{label: t("homePage.review_application_onboarding"), path: "https://myidm.mypepsico.com/pepsicorao/review/review-section", icon: "fact_check"}] : [])]
  const [isTab, setIsTab] = useState(
    window.innerWidth > 768 && window.innerWidth <= 1024
  );
  const hanldleTheNavigation = (linkData) => {
    if (linkData) {
      window.open(`${linkData}`, "_blank", "noopener noreferrer");
    } else {
      const winHtml = page.Error404Page;

      const winUrl = URL.createObjectURL(
        new Blob([winHtml], { type: "text/html" })
      );
      const win = window.open(winUrl, "_blank");
      setTimeout(() => {
        win.close();
      }, 100);
    }
  };

  const selectedPendingApprovalTab = (index) => {
    setSelectedPendingApprovalTabIndex(index);
  };
  const navigateToQuickLinks = (path) => {
    if (path === "/approvals") {
      sessionStorage.setItem("myidMApprovalCount", myidMApprovalCount);
      sessionStorage.setItem("entraCount", entraCount);
      sessionStorage.setItem("myPamCount", myPamCount);
      // if (roles?.includes("isApprovals")) {
      navigate(path, { state: { roles, myidMApprovalCount, entraCount, myPamCount  } });
      // }
    }
    else {
      navigate(path);
    }
  };
  const fetchEntraCount = () => {
    axios
      .post(REACT_APP_API_ENDPOINT + "entra/pendingRequests/count")
      .then((response) => {
        if (response?.data && response?.data?.status === "Success") {
          setEntraCount(response?.data?.requestCount)
        }else{
          setEntraCount(0)
        }
      })
      .catch((error) => {
        console.warn(
          "***** Error thrown for the Access detail api ***** ",
          error?.response?.data?.message
        );
        setEntraCount(0)
      })
    
  }
  const fetchMyPamCount = () => {
    axios
      .get(REACT_APP_API_ENDPOINT + "pam/safeManagement/pendingApprovals/count")
      .then((response) => {
        if (response?.data && response?.data?.success) {
          setMyPamCount(response?.data?.pendingCount)
        }else{
          setMyPamCount(0)
        }
      })
      .catch((error) => {
        console.warn(
          "***** Error thrown for the Access detail api ***** ",
          error?.response?.data?.message
        );
        setMyPamCount(0)
      })
    
  }
  const fetchRequestCount = () => {
    setCountStatus(false);
    var data;
    axios
      .post(REACT_APP_API_ENDPOINT + "user/requestCount")
      .then((response) => {
        if (response?.data && response?.data?.responseStatus === "Success") {
          data = response.data;
          setMyidMApprovalCount(data?.myidmCount);
          setPepAGMApprovalCount(data?.pepAGMCount);
          setCountStatus(true);
        }
        else{
          data = {
            pendingRequests: {
              myidmCount: 0,
              pepAGMCount: 0,
            },
          };
          setMyidMApprovalCount(data?.pendingRequests?.myidmCount);
          setPepAGMApprovalCount(data?.pendingRequests?.pepAGMCount);
          setCountStatus(true);
        }
      })
      .catch((error) => {
        console.warn(
          "***** Error thrown for the Access detail api ***** ",
          error?.response?.data?.message
        );
        data = {
          pendingRequests: {
            myidmCount: 0,
            pepAGMCount: 0,
          },
        };

        setMyidMApprovalCount(data?.pendingRequests?.myidmCount);
        setPepAGMApprovalCount(data?.pendingRequests?.pepAGMCount);
        setCountStatus(true);
      });
  };
  const sections = [
    {
      title: t("myIdmPortal.request_access"),
      items: [
        { icon: "assignment_late", label: t("myIdmPortal.view_requests"), button: t("myIdmPortal.see_details"), subItems: [], className: `view-request-ref hide-show-accordion-btn ${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`},
        { icon: "inventory", label: t("myIdmPortal.request_new_access_for_self"), button: t("myIdmPortal.new_access"), subItems: [], className:`req-new-access-self-ref hide-show-accordion-btn ${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`, subTitle: t("myIdmPortal.general_application_request")}, 
        { icon: "edit", label: t("myIdmPortal.modify_disable_access_for_self"), button: t("myIdmPortal.modify"), subItems: [], className:`req-mod-access-self-ref hide-show-accordion-btn ${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`, subTitle: t("myIdmPortal.general_application_request") }, 
        ...((userProfile?.associateType?.toLowerCase() === "thirdparty") ? [] : [
        { icon: "snippet_folder", label: t("myIdmPortal.request_new_access_for_others"), button: t("myIdmPortal.new_access"), subItems: [], className: `request-access-others-ref hide-show-accordion-btn ${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}` },
        { icon: "edit", label: t("myIdmPortal.modify_disable_access_for_others"), button: t("myIdmPortal.modify"), subItems: [], className:`request-access-others-mod-ref hide-show-accordion-btn ${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}` }

      ])
      ]
    },
    {
      title: t("myIdmPortal.manage_my_account"),
      items: [
        { icon: "history", label: userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile') ? t("myIdmPortal.update_profile") : t("homePage.view_profile"), button: userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile') ? t("myIdmPortal.edit_my_profile") : t("myIdmPortal.view_my_profile"), subItems: [], className: `update-profile-ref hide-accordion-expend-icon ${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}` },
        // { icon: "mail", label: "Validate Phone and Non-Pepsico Email using OTP", button: "Validate", subItems: [], className: "update-profile-email-ref hide-accordion-expend-icon ellipsis-two-lines" },
        ...((userProfile?.associateType?.toLowerCase() === "contractor" || userProfile?.associateType?.toLowerCase() === "thirdparty") ? [{ icon: "create_new_folder", label: t("myIdmPortal.non_employee_extension_for_self"), button: t("myIdmPortal.self"), subItems: [], className: `hide-accordion-expend-icon${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}` }] : []),
        { icon: "lock", label:  t("myIdmPortal.change_password"), button: t("myIdmPortal.click_here"), subItems: [], className: `change-password-ref hide-accordion-expend-icon ${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}` },

      ]
    },
    {
      title: t("myIdmPortal.manage_other_accounts"),
      items: [
        // { icon: "account_box", label: "Request GPID for a non-employee", button: null, subItems: [] },
        // { icon: "alt_route", label: "Contractor to Employee Conversion", button: null, subItems: [] },
        // { icon: "keyboard_tab", label: "Termination request", button: null, subItems: [] },
        ...((userProfile?.pepappiamcentralfeatures?.includes('UpdateProfileOthers') && userProfile?.associateType?.toLowerCase() !== "thirdparty") ? [{ icon: "history", label: "Update Profile for Others", type: "profile_edit", subItems: [], className: "update-profile-others-ref" }] : []),
        ...((userProfile?.associateType?.toLowerCase() === "thirdparty") ? [] : [{
          icon: "extension", label: t("myIdmPortal.extension_reactivation"), button: null,className: "exe-react-ref", subItems: [{ icon: null, label: t("myIdmPortal.single_action_for_others"), button: t("myIdmPortal.request"),className :`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}` },
          ...(isManager ? [{ icon: null, label: t("myIdmPortal.bulk_revalidation_for_others"), button: t("myIdmPortal.request"),className:`${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}` }] : [])]
        }]),
        // { icon: "snippet_folder", label: "Request access for others", button: null, subItems: [] },

      ]
    }
  ].filter((tab)=>tab.items.length);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [selectedSectionIndex, setSelectedSectionIndex] = useState(0);
  const [requestNumber, setRequestNumber] = useState("");

  console.log("ismanager::::::::::", userProfile?.isManager);


  useEffect(()=>{
    const eles = document.getElementsByClassName("hide-show-accordion-btn");
    for(const el of eles){
      const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation) => {
          if(mutation.type === "attributes" && mutation.attributeName === "aria-expanded"){
            const isExpended = el.getAttribute("aria-expanded") == "true";
            const elBtn = el.querySelector(":not(.sub_items_list) > .item-button")
            if(isExpended){
              if(elBtn && elBtn.style){
                elBtn.style.display = "none";
              }
            } 
            else{
              if(elBtn && elBtn.style){
                elBtn.style.display = "flex";
              }
            }
          }
        })
      });

      observer.observe(el, {
        attributes: true,
        attributeFilter: ["aria-expanded"]
      })
    }
  },[])

    useEffect(() => {
    if (state?.navigateFrom === 'request_access_others') {
      const ele = document.querySelector('.request-access-others-ref');
      ele.setAttribute("aria-expanded", "true");
      const inputEle = document.querySelector('.request-access-others-ref .accordion-item-content .search-input input');
      inputEle?.focus();
      inputEle.scrollIntoView({ behavior: "smooth" });
    } else if (state?.navigateFrom === 'extension_request') {
      const ele = document.querySelector('.view-request-ref');
      ele.setAttribute("aria-expanded", "true");
      const inputEle = document.querySelector('.view-request-ref .accordion-item-content .search-input input');
      inputEle?.focus();
      if(state?.requestId) inputEle.value = state?.requestId;
    }
    else if (state?.navigateFrom === 'update_profile_others') {
      const ele = document.querySelector('.update-profile-others-ref');
      ele.setAttribute("aria-expanded", "true");
      const inputEle = document.querySelector('.update-profile-others-ref .accordion-item-content .text-input input');
      inputEle?.focus();
      inputEle.scrollIntoView({ behavior: "smooth" });
    }
    fetchRequestCount();
    fetchEntraCount();
    fetchMyPamCount();
  }, [])


  useEffect(() => {
    loadAccordianBtns();
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [selectedSectionIndex, isMobile, i18n.language]);

  const loadAccordianBtns = () => {
    const container = document.querySelector('.myidm-container');
    if (container) {
      const columns = container.querySelectorAll('.column');
      const oldTags = container.querySelectorAll('.tag.color-tag-black');
      oldTags.forEach(tag => tag.remove());
      columns.forEach((col, index) => {
        const items = col.querySelectorAll('.accordion-item-v1');
        items.forEach((item, itemIndex) => {

          let sectionButton;
          if (isMobile) {
            sectionButton = sections[selectedSectionIndex].items[itemIndex].button;
          } else {
            sectionButton = sections[index].items[itemIndex].button;
          }
          const itemContainer = item.querySelector('.accordion-item-container');
          if (sectionButton) {
            const isArabic = i18n.language === 'ar' || i18n.language === 'ar-SA';
            const outerSpan = document.createElement('span');
            outerSpan.className = 'tag color-tag-black large default $font-xsmall-regular';
            outerSpan.style.position = 'absolute';
            if(isArabic){
              outerSpan.style.left = '40px';
            } else {
              outerSpan.style.right = '40px';
            }

            const labelSpan = document.createElement('span');
            labelSpan.className = 'tag-label';

            const buttonSpan = document.createElement('span');
            buttonSpan.className = 'item-button';
            if (isMobile ? selectedSectionIndex == 1 : index == 1) {
              // buttonSpan.innerHTML = ` ${sectionButton} <span class="material-icons" style="font-size: 18px; margin-left: 4px;">arrow_forward</span>`;
              buttonSpan.innerHTML = ` ${sectionButton}`;
            } else {
              buttonSpan.textContent = sectionButton;
            }
            buttonSpan.addEventListener('click', () => {
              let itemValue = isMobile ? sections[selectedSectionIndex].items[itemIndex] : sections[index].items[itemIndex];
              handleClick(itemValue);
            });
            labelSpan.appendChild(buttonSpan);
            outerSpan.appendChild(labelSpan);
            itemContainer?.appendChild(outerSpan);
          }
        })
      })
    }
  }

  const selectedTab = (index) => {
    setSelectedTabIndex(index);
  };

  const handleDropdownChange = (label, value) => {
    if (label === "Search By") {
      setSelectedProfileValue(value);
      setSearchByValue(value?.[0]?.id || "");
    }
  }

  const showOthersUsers = () => {
    if (selectedTabIndex === 0 && gpid) {
      navigate('/update-others-profile', { state: { searchByType: 'gpid', gpid } });
    }
    else if (selectedTabIndex === 1 && searchByValue && otherOptionsValue) {
      navigate('/update-others-profile', { state: { searchByType: searchByValue, [searchByValue]: otherOptionsValue } });
    }
  }

  const onClickTab = (index) => {
    setSelectedSectionIndex(index);
  };

  const handleClick = (item) => {
    console.log("Clicked item:", item);
    if (
      item.label === t("myIdmPortal.update_profile") ||
      item.label === t("myIdmPortal.validate_phone_and_non_pepsico_email_using_otp")
    ) {
      const isEmailValidate = item.label === t("myIdmPortal.validate_phone_and_non_pepsico_email_using_otp");
      if(userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile')){
      navigate("/update-profile", {
        state: { isEmailValidate }
      });
    }
    else{
      if(userProfile?.associateType.toLowerCase()?.includes("employee") ){
        window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoModifyEmployeeProfile", "_blank");
        // navigate('/update-profile');
      }
      else {
        window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoModifyNonEmployeeProfileForAnother", "_blank");
        // navigate('/update-profile');
      }
    }
    }
    if(item.label === t("homePage.view_profile")){
      navigate("/view-profile");
    }
    if (item.label === 'Update Profile for Others') {
      navigate('/update-others-profile');
    }
    if (item.label === t("myIdmPortal.non_employee_extension_for_self")) {
      userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation') ?
      navigate("/extension-request"):
      window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ExtensionReactivationNonEmployeeSelfRequest","_blank")
    }
    if (item.label === "Change password" || item.label === t("myIdmPortal.change_password")) {
      navigate("/change-password");
    }
  };

  const handleSubItem = (item) => {
    if (item.label === t("myIdmPortal.single_action_for_others")) {
      userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation') ?
      navigate("/single-extension-reactivation") :
      window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ExtensionReactivationNonEmployeeSelfRequest","_blank")
    }
    if (item.label === t("myIdmPortal.bulk_revalidation_for_others")) {
      userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation') ?
      navigate("/bulk-revalidation"):
      window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoBulkRevalidationNonEmployee","_blank")
    }
  }

  const onClickMyRequest = () => {
    userProfile?.pepappiamcentralfeatures?.includes('RequestAudit') ? navigate("/audit-requests"): 
    window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ViewMyRequestsAuditSAP")
  };

  const onClickFindRequest = () => {
    if(!userProfile?.pepappiamcentralfeatures?.includes('RequestAudit')){
      window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ViewMyRequestsAuditSAP")
    }
    else{
    let statePayload = {};

    if (requestNumber) {
      if(requestNumber.length < 4){
          toast.error(t("auditRequest.search_limit_message"));
          return
      }else{
        statePayload = { type: "requestNumber", value: requestNumber};
        navigate("/audit-requests", { state: statePayload });
      }
    }
    else if (selectedValue?.[0].displayText && selectedText) {
      const searchType = selectedValue?.[0].displayText;
      statePayload = { type: searchType, value: selectedText };

      if (searchType === t('myIdmPortal.gpid')) {
        if(selectedText.length !== 8){
          toast.error(t("auditRequest.gpid_limit_message"));
          return
        }else{
          navigate("/audit-requests", { state: statePayload });
        }
      } else if ([t('myIdmPortal.first_name'), t('myIdmPortal.last_name'), t('myIdmPortal.email')].includes(searchType)) {
        navigate("/user-audit-requests", { state: statePayload });
      }
    }
  }
  };


  const onUpdateSearchValue = (e) => {
    e.preventDefault();
    let filteredValue = e.target.value;
        switch (selectedDdLabel) {
            case "GPID":
                filteredValue = e.target.value.replace(/[^0-9]/g, "");
                break;
            case t("myIdmPortal.first_name"):
            case t("myIdmPortal.last_name"):
                filteredValue = e.target.value.replace(/[^A-Za-z\s]/g, "");
                break;
            default:
                break;
        };
         setSelectedText(filteredValue);
        
  }
  const onChangeDropdown = (value) => {
    setSelectedValue(value);
    setSelectedDdLabel(value[0].displayText);
    setSelectedText("");
    const parent = document.querySelector('.other-options');
    if (parent) {
    const menuList = parent.querySelector('.menu-list');
    if (menuList) {
       menuList.style.display = 'none';
     }
  }
  }
  const myPendingRequest = () => {
    return (
      <div className="my-request-container">
        <div>
        <TabsNavigation selectedIndex={selectedIndex}>
          <Tab label={t("myIdmPortal.request_number")} onClick={() => setSelectedIndex(0)} />
          <Tab label={t("myIdmPortal.other_options")} onClick={() => setSelectedIndex(1)} />
        </TabsNavigation>
        <br></br>

        {(selectedIndex == 0) && (
          <>
            <Label
              className=""
              label={t("myIdmPortal.search_a_req_number")}
              style={{}}
            />
            <Search
              className=""
              isClearable
              menuPosition="bottom-right"
              onClear={function oFe() { }}
              onSearch={function oFe() { }}
              onSelectOption={function oFe() { }}
              onUpdate={(e) => setRequestNumber(e)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  onClickFindRequest()
                }
              }}
              placeholderText={t("myIdmPortal.type_request_number")}
              size="medium"
              style={{maxWidth:"revert"}}
              delay={0}
            />
          </>
        )}
        {(selectedIndex == 1) && (
          <>
            <Dropdown
              childList={[
                {
                  displayText: t('myIdmPortal.gpid'),
                  id: '1',
                },
                {
                  displayText: t('myIdmPortal.first_name'),
                  id: '2',
                },
                {
                  displayText: t('myIdmPortal.last_name'),
                  id: '3',
                },
                {
                  displayText: t('myIdmPortal.email'),
                  id: '4',
                }
              ].sort((a, b) => { return a.displayText.localeCompare(b.displayText); })}
              selectedValue={
                selectedValue}
              className="other-options"
              // dropdownHeader="Menu List"
              feedbackType=""
              showLabelIcon={false}
              isClearable={false}
              isRequired={false}
              label="Search by"
              menuPosition="bottom-right"
              placeholder="Search..."
              selection="single"
              setSelectedValue={(value) => onChangeDropdown(value)}
              size="medium"
              style={{ marginBottom: "16px"}}
              onKeyDown={(e) => e.preventDefault()}
            />

            <input
            className="request-input"
              label=""
              onChange={(e) => onUpdateSearchValue(e)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  onClickFindRequest()
                }
              }}
              placeholder={`Enter ${selectedDdLabel}`}
              value={selectedText}
            />
          </>
        )}
        <button className="request-button" onClick={() => onClickFindRequest()}>
          <span>{t("myIdmPortal.find_requests")}</span>
          <Icon
            alt="alt value"
            icon="arrow_forward"
            size="medium"
            style={{ marginLeft: '4px' }}
          />
        </button>
        <button className="my-request-button" onClick={() => onClickMyRequest()}>
          <span>{t("myIdmPortal.view_my_requests")}</span>
        </button>
        </div>
      </div>
    );
  };

  
  const myRequestAccess = (label) => {
    return (
      <div className="my-request-container">
        <div
          className="innerTitleInfo"
          style={{ display: "contents" }}
        >
          {/* <div
            className="link mb-2"
            onClick={() => {
              navigate("/request-access")
              // window.open(
              //   "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestNewAccessForSelf",
              //   "_blank"
              // );
            }}
            style={{ fontSize: "10px" }}
          >
            {t("homePage.general_application_request")}
          </div> */}

          <button className="request-button mt-0" 
          onClick={() => {
          if (userProfile?.pepappiamcentralfeatures?.includes('RequestAccess')) {
          navigate( label == "Request New Access for Self" ? "/request-new-access" :"/request-access")
          
        } else {
        window.open(
          "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestNewAccessForSelf",
          "_blank"
        );
      }
    }}
    >
            <span>{label == t("myIdmPortal.request_new_access_for_self") ? t("myIdmPortal.request_new_access") : t("myIdmPortal.modify_disable")}</span>
          </button>
          <hr />
          <div className="mb-2" style={{fontWeight:"bold", fontSize:"14px"}}>{t("myIdmPortal.other_requests")}</div>
          <div className="d-flex justify-content-between">
            <div style={{fontSize:"14px"}}>
              {t("homePage.sap_access_request")}
            </div>
            <div
              className="link mb-2"
              onClick={() => {
                window.open(
                  "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestSAPAccess%7D&task.clear=1",
                  "_blank"
                );
              }}
              style={{ fontSize: "10px" }}
            >
              <Icon
                alt="alt value"
                icon="arrow_forward"
                size="medium"
                style={{ marginLeft: '4px' }}
              />
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div style={{fontSize:"14px"}}>
              {t("homePage.technology_application_request")}
            </div>
            <div
              className="link"
              onClick={() => {
                window.open(
                  "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.TechnologyRequest.name%7D&task.clear=1",
                  "_blank"
                );
              }}
              style={{ fontSize: "10px" }}
            >
              <Icon
                alt="alt value"
                icon="arrow_forward"
                size="medium"
                style={{ marginLeft: '4px' }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const requestOthersOnChangeDropdown = (value) => {
    setRequestOthersSelectedValue(value[0].displayText);
    setRequestOthersSelectedDdLabel(value[0].displayText)
  }

  const requestOthersOnUpdateSearchValue = (e) => {
    setRequestOthersSelectedText(e);
  }

  const onClickFindProfile = () => {
    let statePayload = {};

    if (requestOthersSelectedIndex == 0 && requestOthersGPID) {
      if(userProfile?.pepappiamcentralfeatures?.includes('RequestAccess')) {
        statePayload = { type: `${t('RequestNewAccessForOthers.gpid')}`, value: requestOthersGPID };
        navigate("/request-new-access-others", { state: statePayload });
      }
      else{
        window.open(
          "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestAccessForOtherAssociate",
          "_blank"
        );
      }
      
    }
    else if (requestOthersSelectedValue && requestOthersSelectedText) {
      if(userProfile?.pepappiamcentralfeatures?.includes('RequestAccess')) {
      statePayload = { type: requestOthersSelectedValue, value: requestOthersSelectedText };
      navigate("/request-new-access-others", { state: statePayload });
      }
      else{
        window.open(
          "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestAccessForOtherAssociate",
          "_blank"
        );
      }
    }
  }

const requestNewAccessForOthers = () => {
    return (
      <div className="my-request-container">
        <TabsNavigation selectedIndex={requestOthersSelectedIndex}>
          <Tab label={`${t('RequestNewAccessForOthers.gpid')}`} onClick={() => setRequestOthersSelectedIndex(0)} />
          <Tab label={`${t('RequestNewAccessForOthers.other_options')}`} onClick={() => setRequestOthersSelectedIndex(1)} />
        </TabsNavigation>
        <br></br>

        {(requestOthersSelectedIndex == 0) && (
          <>
            {/* <Label
              className=""
              label={`${t('RequestNewAccessForOthers.gpid')}`}
              style={{}}
            /> */}
            <Search
              icon=""
              className=""
              isClearable
              menuPosition="bottom-right"
              onClear={function oFe() { }}
              onSearch={function oFe() { }}
              onSelectOption={function oFe() { }}
              onUpdate={(e) => setRequestOthersGPID(e)}
              placeholderText={`${t('RequestNewAccessForOthers.type_gpid')}`}
              size="medium"
              style={{}}
              delay={0}
            />
          </>
        )}
        {(requestOthersSelectedIndex == 1) && (
          <>
            <Dropdown
              childList={[
                {
                  displayText: `${t('updateProfile.firstName')}`,
                  id: '1',
                },
                {
                  displayText: `${t('updateProfile.lastName')}`,
                  id: '2',
                },
                {
                  displayText: `${t('RequestGPIDForNonEmployee.email_label')}`,
                  id: '3',
                }
              ].sort((a, b) => { return a.displayText.localeCompare(b.displayText); })}
              label={`${t('RequestNewAccessForOthers.search_by')}`}
              value={
                requestOthersSelectedValue}
              placeholder={`${t('RequestGPIDForNonEmployee.search')}...`}
              isClearable={false}
              selection="single"
              size="medium"
              className="other-options"
              setSelectedValue={(value) => requestOthersOnChangeDropdown(value)}
              style={{ marginBottom: "16px"}}
              onKeyDown={(e) => e.preventDefault()}
            />

            <TextInput
              className=""
              feedbackType="info"
              inputSize="medium"
              // label={`${requestOthersSelectedDdLabel}`}
              label=""
              onChange={function oFe() { }}
              onUpdate={(e) => requestOthersOnUpdateSearchValue(e)}
              placeholderText={`${t('RequestNewAccessForOthers.enter')} ${requestOthersSelectedDdLabel}`}
              prefixType="none"
              style={{}}
              suffixType="none"
              type="text"
              value={requestOthersSelectedText}
            />
          </>
        )}
        <button
          className="request-button"
          onClick={() => onClickFindProfile()}
          disabled={requestOthersSelectedIndex == 0 ? (!requestOthersGPID || requestOthersGPID?.length < 4) : (!requestOthersSelectedText || requestOthersSelectedText.length < 2)}
        >
          <span>{`${t('RequestNewAccessForOthers.find_profile')}`}</span>
          <Icon
            alt=""
            icon="arrow_forward"
            size="medium"
            style={{ marginLeft: '4px' }}
          />
        </button>
         <hr />
          <div className="mb-2" style={{fontWeight:"bold", fontSize:"14px"}}>Other Requests</div>
          <div className="d-flex justify-content-between">
            <div style={{fontSize:"14px"}}>
              {t("homePage.sap_access_request")}
            </div>
            <div
              className="link mb-2"
              onClick={() => {
                window.open(
                  "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestSAPAccess%7D&task.clear=1",
                  "_blank"
                );
              }}
              style={{ fontSize: "10px" }}
            >
              <Icon
                alt="alt value"
                icon="arrow_forward"
                size="medium"
                style={{ marginLeft: '4px' }}
              />
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div style={{fontSize:"14px"}}>
              {t("homePage.technology_application_request")}
            </div>
            <div
              className="link"
              onClick={() => {
                window.open(
                  "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.TechnologyRequest.name%7D&task.clear=1",
                  "_blank"
                );
              }}
              style={{ fontSize: "10px" }}
            >
              <Icon
                alt="alt value"
                icon="arrow_forward"
                size="medium"
                style={{ marginLeft: '4px' }}
              />
            </div>
          </div>
      </div>
    );
  };


  const renderIdmyList = () => {
    return (
      <div id="myidm_container" className="myidm-container">
        <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            draggable
        />
        {sections.map((section, index) => (
          <div className="column" key={index}>
            <h2 style={{ fontSize: '14px', margin: "unset !important", fontWeight: "bold" }}>{section.title}</h2>
            {section.items.map((item, itemIndex) => (
              <AccordionItemV2 key={itemIndex}
                icon={item.icon}
                label={item.label}
                disabled ={userProfile?.systemsStatus?.myidM}
                className={item.className || ""}
                subTitle={item.subTitle || ""}
                onUpdate={function IAe() { }}
                presentation="box-shadow"
                rightAccessory={{
                  tagProps: {
                    color: 'black',
                    isCopyable: false,
                    onRemove: function IAe() { },
                    size: 'large',
                    // text: `${item.button !== null ? index == 1 ? `${item.button} ->` : item.button : ''}`
                    text: item.button !== null ? (
                      <span className="item-button"
                        onClick={() => handleClick(item)}
                      >
                        {index === 1 ? (
                          <>
                            {item.button}
                            {/* <Icon
                              alt="alt value"
                              icon="arrow_forward"
                              size="medium"
                              style={{ fontSize: '18px' }}
                            /> */}
                          </>
                        ) : (
                          item.button
                        )}

                      </span>
                    ) : ''
                  }
                }}
              >
               {(item.label ==t("myIdmPortal.view_requests")) && (
                  <Font textColorClass="$color-text-secondary">
                    {myPendingRequest()}
                  </Font>
                )}
                {(item.label == t("myIdmPortal.request_new_access_for_self") || item.label == t("myIdmPortal.modify_disable_access_for_self")) && (
                  <Font textColorClass="$color-text-secondary">
                    {myRequestAccess(item.label)}
                  </Font>
                )}
                {(item.label == t("myIdmPortal.request_new_access_for_others") || item.label ==t("myIdmPortal.modify_disable_access_for_others")) && (
                  <Font textColorClass="$color-text-secondary">
                    {/* {requestNewAccessForOthers()} */}
                    <NewOrModifyAccess />
                  </Font>
                )}
                <Font textColorClass="$color-text-secondary">
                  {item.subItems.map((subItem, subIndex) => (
                    <div className="sub_items_list mb-2" key={subIndex}>
                      <p className="mb-0">{subItem.label}</p>
                      {subItem.button && (
                        <span
                          className="item-button"
                          onClick={() => handleSubItem(subItem)}
                        >
                          <>
                            {subItem.button}
                            <Icon
                              alt="alt value"
                              icon="arrow_forward"
                              size="large"
                              style={{ marginLeft: '4px', fontSize: '22px' }}
                            />
                          </>

                        </span>
                      )}
                    </div>
                  ))}

                </Font>
                {item?.type === "profile_edit" ? (
                  <div>
                    <TabsNavigation
                      className=""
                      onUpdate={selectedTab}
                      selectedIndex={selectedTabIndex}
                      style={{}}
                    >
                      <Tab
                        label="GPID"
                        onClick={function aFe() { }}
                      />
                      <Tab
                        label="Other Options"
                        onClick={function aFe() { }}
                      />
                    </TabsNavigation>
                    <div className="tab-content pb-4">
                      {selectedTabIndex === 0 ? (
                        <div className="d-grid px-1 py-2" style={{ gap: '12px' }}>
                          {/* <TextInput
                            label="GPID"
                            value={gpid}
                            onChange={(e) => setGpid(e.target.value)}
                          /> */}
                          <Search
                            icon=""
                            className=""
                            isClearable={gpid.length>0}
                            menuPosition="bottom-right"
                            onClear={function oFe() { }}
                            onSearch={function oFe() { }}
                            onSelectOption={function oFe() { }}
                            onUpdate={(e) =>{
                              const GPID = e?.replace?.(/[^0-9]/g, "");
                              setGpid(GPID);
                            }}
                            placeholderText={`${t('RequestNewAccessForOthers.type_gpid')}`}
                            size="medium"
                            style={{maxWidth:"revert"}}
                            value={gpid}
                            delay={0}
                          />
                        </div>
                      ) : (
                        <div className="d-grid px-1 py-2" style={{ gap: '12px' }}>
                          <Dropdown
                            childList={[
                              { displayText: t('myIdmPortal.first_name'), id: "first_name" },
                              { displayText: t('myIdmPortal.last_name'), id: "last_name" },
                              { displayText: t('myIdmPortal.email'), id: "email" },
                            ].sort((a, b) => { return a.displayText.localeCompare(b.displayText); })}
                            label="Search By"
                            appendTo="body"
                            placeholder="Search By"
                            selectedValue={selectedProfileValue}
                            isClearable={false}
                            feedbackType="info"
                            showLabelIcon={false}
                            isRequired={false}
                            
                            selection="single"
                            size="medium"
                            setSelectedValue={(value) => handleDropdownChange("Search By", value)}
                            onKeyDown={(e) => e.preventDefault()}
                          />
                          {selectedProfileValue?.[0]?.displayText && selectedProfileValue?.[0]?.displayText !== "" && (
                            <TextInput
                              label={selectedProfileValue?.[0]?.displayText ? selectedProfileValue?.[0]?.displayText : "Other Options"}
                              value={otherOptionsValue}
                              onChange={(e) => setOtherOptionsValue(e.target.value)}
                              placeholderText={`${t('RequestNewAccessForOthers.enter')} ${selectedProfileValue?.[0]?.displayText ? selectedProfileValue?.[0]?.displayText : "Other Options"}`}
                            />
                          )}
                        </div>
                      )}
                      <Button text="Find profile" iconTrailing="arrow_forward" size="medium" style={{ justifyContent: 'center', width: '100%' }} onClick={() => showOthersUsers()} />
                    </div>
                  </div>
                ) : null}
              </AccordionItemV2>
            ))}
            { 
              section.title === t("myIdmPortal.manage_my_account") ? 
              <>
                <h2 style={{ fontSize: '14px', margin: "unset !important", fontWeight: "bold" }}>{t("homePage.approvals")} / {t("homePage.actions")}</h2>
                <div
                  className={`card  ${isTab ? "subCard" : "maincard"}`}
                  style={{
                    padding: "12px",
                    minHeight: "215px",
                    gap: "var(--spacing-04, 16px)"
                  }}
                >
                  <div style={{ padding: "8px 0px", display: "flex" }}>
                    <Switcher
                      items={[
                        {
                          label: t("homePage.pending")
                        },
                        {
                          label: t("homePage.overdue")
                        }
                      ]}
                      onUpdate={(val) => selectedPendingApprovalTab(val)}
                      selectedItemIndex={selectedPendingApprovalTabIndex}
                    />
                    <Icon
                        alt="alt value"
                        className="$color-icon-default p-1 mr-1"
                        icon="refresh"
                        data-tooltip-id="refresh-tooltip" data-tooltip-content="Refresh"
                        size="small"
                        onClick={() => {fetchRequestCount();fetchEntraCount();fetchMyPamCount();}}
                        style={{ alignItems: 'center', marginLeft: '0.5rem', cursor: 'pointer' }}
                    />
                  </div>
                  {selectedPendingApprovalTabIndex === 0 && (
                    <div className="card approvalCard" style={{ margin: 0 }}>
                      <div
                        className="card-content w-full"
                        style={{ padding: "6px", display: "grid" }}
                      >
                        {!countStatus && (
                          <div
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            <LoadingSpinner
                              size={{
                                height: "50px",
                                width: "50px",
                              }}
                            />
                          </div>
                        )}
                        {countStatus && (
                          <div>
                            <h3
                              className="bold-text text-left pl-md-3"
                              // style={{ paddingLeft: "20px" }}
                            >
                              {(userProfile?.pepappiamcentralfeatures?.includes('SafeManagement') ? Number(myPamCount) : 0) + (userProfile?.pepappiamcentralfeatures?.includes('GuestInvitation') ? Number(entraCount) : 0) + Number(myidMApprovalCount) +
                                (pepAGMApprovalCount == "10+"
                                  ? 10
                                  : Number(pepAGMApprovalCount))}
                              {pepAGMApprovalCount == "10+" ? "+" : ""}{" "}
                            </h3>
                            <div>
                              <div
                              className="px-md-3"
                                style={{
                                  textAlign: "left",
                                  display: "grid",
                                  // padding: "0px 20px",
                                }}
                              >
                                {/* <h3 className="bold-text">{myidMApprovalCount + pepAGMApprovalCount}</h3> */}
                                {(userProfile?.pepappiamcentralfeatures?.includes('SafeManagement') ? Number(myPamCount) : 0) + (userProfile?.pepappiamcentralfeatures?.includes('GuestInvitation') ? Number(entraCount) : 0) + Number(myidMApprovalCount) +
                                  (pepAGMApprovalCount === "10+"
                                    ? 10
                                    : Number(pepAGMApprovalCount)) ===
                                  0 && (
                                    <span
                                      style={{ textAlign: "left" }}
                                      className="accordion-item-label"
                                    >
                                      {t("homePage.pending_desc")}
                                    </span>
                                  )}
                                {myidMApprovalCount > 0 && (
                                  <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                    <span className="accordion-item-label">
                                      myidM - {myidMApprovalCount}
                                    </span>
                                    <span>
                                      <Link
                                        onClick={() => {
                                          userProfile?.pepappiamcentralfeatures?.includes('Approvals') ? 
                                          navigateToQuickLinks("/approvals"):
                                        window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PendingApprovals","_blank")
                                        }}
                                        // target="_blank"
                                        label={`${t("approvals.approve")}/${t("approvals.reject")}`}
                                        // showIconTrailing
                                        style={{
                                          paddingLeft: "2.75rem",
                                          paddingRight: "0.75rem",
                                        }}
                                        useAnchor
                                        size="small"
                                      />
                                    </span>
                                  </span>
                                )}
                                {(pepAGMApprovalCount > 0 ||
                                  pepAGMApprovalCount == "10+") && (
                                    <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                      <span className="accordion-item-label" style={{ width: '90px' }}>
                                        pepAGM - {pepAGMApprovalCount}
                                      </span>
                                      <span>
                                        <Link
                                          href="https://pepagm.mypepsico.com/sigma/app/index#/campaigns"
                                          target="_blank"
                                          label={`${t("approvals.maintain")}/${t("approvals.revoke")}`}
                                          // showIconTrailing
                                          style={{
                                            paddingLeft: "2rem",
                                            paddingRight: "0.75rem",
                                          }}
                                          useAnchor
                                          size="small"
                                        />
                                      </span>
                                    </span>
                                  )}
                                  {entraCount > 0  && userProfile?.pepappiamcentralfeatures?.includes('GuestInvitation') && (
                                    <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                      <span className="accordion-item-label" style={{ width: '90px' }}>
                                        {t("entraGuest.entra")} - {entraCount}
                                      </span>
                                      <span>
                                        <Link
                                          onClick={() => {
                                            sessionStorage.setItem("myidMApprovalCount", myidMApprovalCount);
                                            sessionStorage.setItem("entraCount", entraCount);
                                            sessionStorage.setItem("myPamCount", myPamCount);
                                            navigate("/approvals", { state: { isEntraApproval:true, myidMApprovalCount, entraCount, myPamCount } });
                                          }}
                                          label={`${t("approvals.approve")}/${t("approvals.reject")}`}
                                          style={{
                                            paddingLeft: "2.75rem",
                                            paddingRight: "0.75rem",
                                          }}
                                          useAnchor
                                          size="small"
                                        />
                                      </span>
                                    </span>
                                  )}
                                  {myPamCount > 0 && userProfile?.pepappiamcentralfeatures?.includes('SafeManagement')  && (
                                    <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                      <span className="accordion-item-label" style={{ width: '90px' }}>
                                        {t("homePage.mypam")} - {myPamCount}
                                      </span>
                                      <span>
                                        <Link
                                          onClick={() => {
                                            sessionStorage.setItem("myidMApprovalCount", myidMApprovalCount);
                                            sessionStorage.setItem("entraCount", entraCount);
                                            sessionStorage.setItem("myPamCount", myPamCount);
                                            navigate("/approvals", { state: { isMyPamApproval:true, myidMApprovalCount, entraCount, myPamCount } });
                                          }}
                                          label={`${t("approvals.approve")}/${t("approvals.reject")}`}
                                          style={{
                                            paddingLeft: "2.75rem",
                                            paddingRight: "0.75rem",
                                          }}
                                          useAnchor
                                          size="small"
                                        />
                                      </span>
                                    </span>
                                  )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {(selectedPendingApprovalTabIndex === 3 ||
                    selectedPendingApprovalTabIndex === 1) && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "-webkit-fill-available",
                        }}
                      >
                        <span> {t("homePage.coming_soon")}</span>
                      </div>
                    )}
                  {selectedPendingApprovalTabIndex === 2 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {/* <img
                        src={work_inprogress}
                        style={{ minWidth: "150px", width: "150px" }}
                        alt="work in progress"
                      /> */}
                    </div>
                  )}
                </div>
                <h2 style={{ fontSize: '14px', margin: "unset !important", fontWeight: "bold" }}>{t("homePage.application_onboarding")}</h2>
                <>
                {
                  applicationOnboarding.map((item)=>{
                    return <div
                  className="card idmCard h-auto"
                >
                  <div
                    className="card-content my-0"
                    style={{ margin: "auto" }}
                    onClick={() =>hanldleTheNavigation(item?.path)}
                  >
                    <div className="d-flex col-12">
                      <Icon
                        alt="alt value"
                        icon={item?.icon}
                        size="large"
                        style={{ marginLeft: '4px', fontSize: '22px' }}
                      />
                      <div
                        className="col-9"
                        style={{
                          margin: "auto auto auto 6px",
                          display: "grid",
                          maxWidth: "76%",
                          flex: "0 0 76%",
                        }}
                      >
                        <div
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            cursor: "pointer",
                            color: "inherit",
                            fontSize: "14px",
                            textAlign: i18n.language?.split('-')?.[0] === 'ar' ? "right" : "left",
                          }}
                        >
                          {item?.label}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  })
                }
                </>
              </>
              : null
            }
          </div>
        ))}
      </div>
    )
  }

  const renderDesktop = () => {
    return (
      <div className="main-container">
        <h1 style={{ fontSize: '18px', fontWeight: "bold" }} className="page-title ml-3 mb-10">myidM </h1>
        {renderIdmyList()}
      </div>

    );
  }

  const navigateHome = () => {
    navigate('/home');
  }

  const renderMobile = () => {
    return (
      <div className="mobile-idmy-container">
        <div className="my-home-btn" onClick={navigateHome}> <Icon
          alt="alt value"
          icon="arrow_back"
          size="medium"
          style={{ marginRight: '4px', marginTop: '2px' }}
        />Home</div>
        <h4>
          myidM
        </h4>
        <div style={{ marginLeft: 16 }}>
          <TabsNavigation
            className=""
            orientation="vertical"
            selectedIndex={selectedSectionIndex}
            style={{}}
            onUpdate={(index) => onClickTab(index)}
          >
            {sections.map((section, index) => (
              <Tab
                key={index}
                label={section.title}
                orientation="vertical"
              />
            ))}
          </TabsNavigation>
        </div>
        <div className="myidm-container">
          <div className="column">
            {sections[selectedSectionIndex].items.map((item, itemIndex) => (
              <AccordionItemV2
                key={itemIndex}
                className={item.className || ""}
                icon={item.icon}
                label={item.label}
                data-tour={item.label === "View Requests" ? "view-requests-step-2" : `section-item-${itemIndex}`}
                onUpdate={() => { }}
                presentation="box-shadow"
                rightAccessory={{
                  tagProps: {
                    color: 'black',
                    isCopyable: false,
                    onRemove: () => { },
                    size: 'large',
                    text: item.button !== null ? (
                      <span
                        className="item-button"
                        onClick={() => handleClick(item)}
                      >
                        {selectedSectionIndex === 1 ? (<>
                          {item.button}
                          {/* <Icon
                            alt="alt value"
                            icon="arrow_forward"
                            size="large"
                            style={{ fontSize: "18px" }}
                          /> */}
                        </>) : item.button}
                      </span>
                    ) : ''
                  }
                }}
              >
                {(item.label == t("myIdmPortal.view_requests")) && (
                  <Font textColorClass="$color-text-secondary">
                    {myPendingRequest()}
                  </Font>
                )}
                 {(item.label == t("myIdmPortal.request_new_access_for_self") || item.label == t("myIdmPortal.modify_disable_access_for_self")) && (
                  <Font textColorClass="$color-text-secondary">
                    {myRequestAccess(item.label)}
                  </Font>
                )}
                {(item.label == t("myIdmPortal.request_new_access_for_others") || item.label == t("myIdmPortal.modify_disable_access_for_others")) && (
                  <Font textColorClass="$color-text-secondary">
                    {/* {requestNewAccessForOthers()} */}
                    <NewOrModifyAccess />
                  </Font>
                )}
                <Font textColorClass="$color-text-secondary">
                  {item.subItems.map((subItem, subIndex) => (
                    <div className="sub_items_list mb-2" key={subIndex}>
                      <p className="mb-0">{subItem.label}</p>
                      {subItem.button && (
                        <span
                          className="item-button"
                          onClick={() => handleSubItem(subItem)}
                        >
                          <>
                            {subItem.button}
                            <Icon
                              alt="alt value"
                              icon="arrow_forward"
                              size="large"
                              style={{ marginLeft: '4px', fontSize: '22px' }}
                            />
                          </>

                        </span>
                      )}
                    </div>
                  ))}

                </Font>
              </AccordionItemV2>
            ))}
            { 
              selectedSectionIndex == 1 ? 
              <>
                <h2 style={{ fontSize: '14px', margin: "unset !important", fontWeight: "bold" }}>{t("homePage.approvals")} / {t("homePage.actions")}</h2>
                <div
                  className={`card  ${isTab ? "subCard" : "maincard"}`}
                  style={{
                    padding: "12px",
                    minHeight: "215px",
                    gap: "var(--spacing-04, 16px)"
                  }}
                >
                  <div style={{ padding: "8px 0px", display: "flex" }}>
                    <Switcher
                      items={[
                        {
                          label: t("homePage.pending")
                        },
                        {
                          label: t("homePage.overdue")
                        }
                      ]}
                      onUpdate={(val) => selectedPendingApprovalTab(val)}
                      selectedItemIndex={selectedPendingApprovalTabIndex}
                    />
                    <Icon
                        alt="alt value"
                        className="$color-icon-default p-1 mr-1"
                        icon="refresh"
                        data-tooltip-id="refresh-tooltip" data-tooltip-content="Refresh"
                        size="small"
                        onClick={() => fetchRequestCount()}
                        style={{ alignItems: 'center', marginLeft: '0.5rem', cursor: 'pointer' }}
                    />
                  </div>
                  {selectedPendingApprovalTabIndex === 0 && (
                    <div className="card approvalCard" style={{ margin: 0, width: "revert !important" }}>
                      <div
                        className="card-content w-full"
                        style={{ padding: "6px", display: "grid" }}
                      >
                        {!countStatus && (
                          <div
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            <LoadingSpinner
                              size={{
                                height: "50px",
                                width: "50px",
                              }}
                            />
                          </div>
                        )}
                        {countStatus && (
                          <div>
                            <h3
                              className="bold-text text-left pl-md-3"
                              // style={{ paddingLeft: "20px" }}
                            >
                              {Number(myidMApprovalCount) +
                                (pepAGMApprovalCount == "10+"
                                  ? 10
                                  : Number(pepAGMApprovalCount))}
                              {pepAGMApprovalCount == "10+" ? "+" : ""}{" "}
                            </h3>
                            <div>
                              <div
                              className="px-md-3"
                                style={{
                                  textAlign: "left",
                                  display: "grid",
                                  // padding: "0px 20px",
                                }}
                              >
                                {/* <h3 className="bold-text">{myidMApprovalCount + pepAGMApprovalCount}</h3> */}
                                {Number(myidMApprovalCount) +
                                  (pepAGMApprovalCount === "10+"
                                    ? 10
                                    : Number(pepAGMApprovalCount)) ===
                                  0 && (
                                    <span
                                      style={{ textAlign: "left" }}
                                      className="accordion-item-label"
                                    >
                                      {t("homePage.pending_desc")}
                                    </span>
                                  )}
                                {myidMApprovalCount > 0 && (
                                  <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                    <span className="accordion-item-label">
                                      myidM - {myidMApprovalCount}
                                    </span>
                                    <span>
                                      <Link
                                        onClick={() => {
                                          userProfile?.pepappiamcentralfeatures?.includes('Approvals') ? 
                                          navigateToQuickLinks("/approvals"):
                                        window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PendingApprovals","_blank")
                                        }}
                                        // target="_blank"
                                        label={`${t("approvals.approve")}/${t("approvals.reject")}`}
                                        // showIconTrailing
                                        style={{
                                          paddingLeft: "2.75rem",
                                          paddingRight: "0.75rem",
                                        }}
                                        useAnchor
                                        size="small"
                                      />
                                    </span>
                                  </span>
                                )}
                                {(pepAGMApprovalCount > 0 ||
                                  pepAGMApprovalCount == "10+") && (
                                    <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                      <span className="accordion-item-label" style={{ width: '90px' }}>
                                        pepAGM - {pepAGMApprovalCount}
                                      </span>
                                      <span>
                                        <Link
                                          href="https://pepagm.mypepsico.com/sigma/app/index#/campaigns"
                                          target="_blank"
                                          label={`${t("approvals.maintain")}/${t("approvals.revoke")}`}
                                          // showIconTrailing
                                          style={{
                                            paddingLeft: "2rem",
                                            paddingRight: "0.75rem",
                                          }}
                                          useAnchor
                                          size="small"
                                        />
                                      </span>
                                    </span>
                                  )}
                                  {entraCount > 0  && userProfile?.pepappiamcentralfeatures?.includes('GuestInvitation') && (
                                    <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                      <span className="accordion-item-label" style={{ width: '90px' }}>
                                        {t("entraGuest.entra")} - {entraCount}
                                      </span>
                                      <span>
                                        <Link
                                          onClick={() => {
                                            sessionStorage.setItem("myidMApprovalCount", myidMApprovalCount);
                                            sessionStorage.setItem("entraCount", entraCount);
                                            sessionStorage.setItem("myPamCount", myPamCount);
                                            navigate("/approvals", { state: { isEntraApproval:true, myidMApprovalCount, entraCount, myPamCount } });
                                          }}
                                          label={`${t("approvals.approve")}/${t("approvals.reject")}`}
                                          style={{
                                            paddingLeft: "2.75rem",
                                            paddingRight: "0.75rem",
                                          }}
                                          useAnchor
                                          size="small"
                                        />
                                      </span>
                                    </span>
                                  )}
                                  {myPamCount > 0 && userProfile?.pepappiamcentralfeatures?.includes('SafeManagement') && (
                                    <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                      <span className="accordion-item-label" style={{ width: '90px' }}>
                                        {t("homePage.mypam")} - {myPamCount}
                                      </span>
                                      <span>
                                        <Link
                                          onClick={() => {
                                            sessionStorage.setItem("myidMApprovalCount", myidMApprovalCount);
                                            sessionStorage.setItem("entraCount", entraCount);
                                            sessionStorage.setItem("myPamCount", myPamCount);
                                            navigate("/approvals", { state: { isMyPamApproval:true, myidMApprovalCount, entraCount, myPamCount } });
                                          }}
                                          label={`${t("approvals.approve")}/${t("approvals.reject")}`}
                                          style={{
                                            paddingLeft: "2.75rem",
                                            paddingRight: "0.75rem",
                                          }}
                                          useAnchor
                                          size="small"
                                        />
                                      </span>
                                    </span>
                                  )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {(selectedPendingApprovalTabIndex === 3 ||
                    selectedPendingApprovalTabIndex === 1) && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "-webkit-fill-available",
                        }}
                      >
                        <span> {t("homePage.coming_soon")}</span>
                      </div>
                    )}
                  {selectedPendingApprovalTabIndex === 2 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {/* <img
                        src={work_inprogress}
                        style={{ minWidth: "150px", width: "150px" }}
                        alt="work in progress"
                      /> */}
                    </div>
                  )}
                </div>
                <h2 style={{ fontSize: '14px', margin: "unset !important", fontWeight: "bold" }}>{t("homePage.application_onboarding")}</h2>
                <>
                {
                  applicationOnboarding.map((item)=>{
                    return <div
                  className="card idmCard h-auto"
                >
                  <div
                    className="card-content my-0"
                    style={{ margin: "auto" }}
                    onClick={() =>hanldleTheNavigation(item?.path)}
                  >
                    <div className="d-flex col-12">
                      <Icon
                        alt="alt value"
                        icon={item?.icon}
                        size="large"
                        style={{ marginLeft: '4px', fontSize: '22px' }}
                      />
                      <div
                        className="col-9"
                        style={{
                          margin: "auto auto auto 6px",
                          display: "grid",
                          maxWidth: "76%",
                          flex: "0 0 76%",
                        }}
                      >
                        <div
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            cursor: "pointer",
                            color: "inherit",
                            fontSize: "14px",
                            textAlign: i18n.language?.split('-')?.[0] === 'ar' ? "right" : "left",
                          }}
                        >
                          {item?.label}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  })
                }
                </>
              </>
              : null
            }
          </div>
        </div>
      </div>
    );

  }

  return isMobile ? renderMobile() : renderDesktop();
}
export default MyidmView1;
